import { pageHead } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import AdminLengthSettings from "@/pages/admin/AdminLengthSettings";

export const Route = createFileRoute("/admin/length-settings")({
  head: () => pageHead("Admin \u2014 Length Settings \u2014 Modern Fence Install", "Private Modern Fence Install account and management page.", undefined, true),
  component: AdminLengthSettings,
});
